import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    lang: "zh",
    is_prepaid_recharge: "", //判断是预付还是授信：预付或授信(1预付 2授信)',
    creditBalance: "", //授信余额,
    globalPostData: {}, // 列表查询条件
    headerHi: localStorage.getItem("headerHi") ? localStorage.getItem("headerHi") : 100,
    companyState: { status: "", remark: "", source: "" }, //企业状态(0未提交，1待审批，2审核通过，5驳回待提交 ,6异常)  来源 1 EIP 2 火箭
    isPerfect: false, // 是否需要完善企业信息,
    routerPath: "",
    metaInfo: {
      title: "",
      keywords: "",
      description: "",
    },
    /**
     * ALM广告等级
     */
    objectLevelConfig: new Map([
      [1, "广告系列"],
      [2, "广告组"],
      [3, "广告"],
      [4, "PIXEL"],
      [5, "ACCOUNT"]
    ])
  },
  mutations: {
    CHANGE_META_INFO(state, metaInfo) {
      state.metaInfo = metaInfo;
    },
    setGlobalPostData(state, data) {
      state.globalPostData = data;
    },
    changeLang(state, v) {
      if (v) {
        state.lang = v;
      }
    },
    SET_IS_PREPAID_RECHARGE(state, val) {
      //判断是预付还是授信
      state.is_prepaid_recharge = val;
    },
    SET_CREDITBALANCE(state, val) {
      //授信余额
      state.creditBalance = val;
    },
    setCompanyState(state, val) {
      state.companyState = val;
    },
    setIsPerfect(state, val) {
      state.isPerfect = val;
    },
    setRouterPath(state, val) {
      state.routerPath = val;
    },
  },
  getters: {
    getObjectLevelConfig(state) {
      return state.objectLevelConfig;
    }
  },
});
